import Image from "next/image";
import "./Detailslist.scss";
import {
  fetchDoctorsWithFilters,
  fetchTopDoctors,
} from "@/slice/topDoctorsSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchTreatmentPackages } from "@/slice/treatmentPackageSlice";
import { fetchAssistanceData } from "@/slice/fetchAssistances";
import { useState } from "react";

export default function Detailslist({ children, props }) {
  const { heading, filterData, showSearch = true } = props;
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.locale.locale);
  const [selectedFilters, setSelectedFilters] = useState({});

  const handleFilterChange = (value, field) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const applyFilters = () => {
    const filters = {};

    // Build filter object based on selected filters
    Object.keys(selectedFilters).forEach((field) => {
      const value = selectedFilters[field];
      if (!value) return;

      switch (field) {
        case "Experiance":
          filters.experience = { $gte: parseInt(value) };
          break;
        case "Surgeries":
          filters.surgeries = { $gte: parseInt(value) };
          break;
        case "Gender":
          filters.gender = { $eq: value };
          break;
        case "Price Range":
          const [lowerLimit, upperLimit] = value.split("-").map(Number);
          filters.packageCost = {
            $gte: lowerLimit,
            $lte: upperLimit,
          };
          break;
        case "Cities":
          filters.city = { $eq: value };
          break;
        case "Countries":
          filters.country = { $eq: value };
          break;
      }
    });

    // Dispatch appropriate action based on filter type
    if (filters.experience || filters.surgeries || filters.gender) {
      dispatch(
        fetchTopDoctors({
          filters,
          locale: lang,
        })
      );
    } else if (filters.packageCost) {
      dispatch(
        fetchTreatmentPackages({
          filters,
          locale: lang,
        })
      );
    } else if (filters.city || filters.country) {
      dispatch(
        fetchAssistanceData({
          filters,
          locale: lang,
        })
      );
    }
  };

  const resetFilters = () => {
    setSelectedFilters({});
    // Reset to initial data
    dispatch(fetchTopDoctors({ locale: lang }));
  };

  return (
    <>
      <div className="listWrapper">
        <div className="headingContainer">
          <p className="heading">{heading}</p>
        </div>
        {showSearch && (
          <>
            <div
              className={`filtersWrapper ${Object.keys(selectedFilters).length > 0 ? "withReset" : ""}`}
            >
              {filterData?.map((item, i) => {
                return (
                  <div key={i} className="filterContainer">
                    <select
                      className="select"
                      value={selectedFilters[item.title] || ""}
                      onChange={(e) =>
                        handleFilterChange(e.target.value, item.title)
                      }
                    >
                      <option value="">Select {item.title}</option>
                      {item.values?.map((val, i) => {
                        return (
                          <option key={i} value={val.id}>
                            {val.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                );
              })}

              {Object.keys(selectedFilters).length === 0 ? (
                <div className="filterContainer buttonContainer">
                  <button
                    className="searchBtn"
                    onClick={applyFilters}
                    disabled={Object.keys(selectedFilters).length === 0}
                  >
                    Apply Filters
                  </button>
                </div>
              ) : (
                <div className="filterContainer doubleButton">
                  <button className="searchBtn" onClick={applyFilters}>
                    Apply
                  </button>
                  <button
                    className="searchBtn resetBtn"
                    onClick={resetFilters}
                    style={{
                      background:
                        "linear-gradient(135deg, #6b7280 0%, #4b5563 100%)",
                    }}
                  >
                    Clear
                  </button>
                </div>
              )}
            </div>
            <div className="horizontal-line"></div>
          </>
        )}

        <div className="listContainer">{children}</div>
      </div>
    </>
  );
}
